import React from 'react';
import CampaignsTable from "../CampaignsTable";

function CampagneLavageTable(props) {
    return <CampaignsTable {...props} />;
}

export default CampagneLavageTable;
